import { render, staticRenderFns } from "./payed.vue?vue&type=template&id=4e3e92b0&"
import script from "./payed.vue?vue&type=script&lang=js&"
export * from "./payed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports